import { render, staticRenderFns } from "./iframe-wrapper.vue?vue&type=template&id=79b05c6a&"
import script from "./iframe-wrapper.vue?vue&type=script&lang=js&"
export * from "./iframe-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports